export const isMobileScreen = () => {
	return screen.width < 768;
};
